// extracted by mini-css-extract-plugin
export default {"mn-style-quick-edit":"index_mn-style-quick-edit__sjkUH","quickEditModal":"index_quickEditModal__-IdI1"};